import { render } from "./CpsAndGroups.vue?vue&type=template&id=399f8aec&scoped=true"
import script from "./CpsAndGroups.vue?vue&type=script&lang=js"
export * from "./CpsAndGroups.vue?vue&type=script&lang=js"

import "./CpsAndGroups.vue?vue&type=style&index=0&id=399f8aec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-399f8aec"]])

export default __exports__